module.exports = __webpack_public_path__ + "static/media/cesur-home.e431bc4c.jpg";